import { type BannersList } from '@cx-web/api-clients/banners-api/types';
import SharedBannersCarousel from '@cx-web/components/page-template/BannersCarousel';
import useMedia from '@cx-web/ui-shell/use-media';

// RR7 atlas glue for the shared BANNERS_CAROUSEL. The component itself lives once in
// `@cx-web/components/page-template/BannersCarousel` and is shared verbatim with atlas-astro; this file
// only resolves the responsive layout the RR7 way — via `useMedia()` (MediaProvider context) — and
// forwards it. atlas-astro's glue does the same with `useDevice` (no provider inside an island).
export default function BannersCarousel({ banners, interval = 4000 }: { banners: BannersList; interval?: number }) {
  const { isDesktop, isMobile } = useMedia();

  return <SharedBannersCarousel banners={banners} interval={interval} isDesktop={isDesktop} isMobile={isMobile} />;
}
